import { httpRequest } from "@services/http";
import { Job } from "@models/job.model";
import { AudienceChannelHoldout } from "@models/audienceDefinition.model";

export interface CalculateAudienceResponse {
  audience_definition_id: number;
  audience_name: string;
  consumers_matched: number;
  consumers_activated: number;
  consumers_created: number;
  consumers_deactivated: number;
  total_active_members: number;
  total_active: number;
  total_converted: number;
  channel_holdouts?: AudienceChannelHoldout[];
}

export class CommandCalculateAudience {
  async run(audienceId: number): Promise<Job> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/${audienceId}/calculate/`;

    const response = await httpRequest<Job>(url, {
      method: "POST",
      body: JSON.stringify({}),
    });

    return response;
  }
}
